import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/lib/content";
import { SectionHead, Reveal } from "@/components/Kinetic";

const Step = ({ p, i, fill }) => {
  const at = i / PROCESS.length;
  const on = useTransform(fill, [at, at + 0.08], [0, 1], { clamp: true });
  return (
    <li data-testid={`process-step-${p.n}`} className="relative pl-16 lg:pl-0">
      <Reveal delay={0.1 * i}>
        <span className="absolute left-0 top-0 grid h-12 w-12 place-items-center rounded-full bg-ink font-mono text-sm font-medium text-white ring-2 ring-white/15 lg:relative">
          <motion.span style={{ opacity: on }} className="absolute inset-0 rounded-full bg-emerald" />
          <span className="relative">{p.n}</span>
        </span>
        <h3 className="display text-3xl text-white lg:mt-8 lg:text-4xl">{p.title}</h3>
        <p className="mt-3 max-w-[18rem] text-base leading-relaxed text-white/65">{p.desc}</p>
      </Reveal>
    </li>
  );
};

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.6"] });
  const fill = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="process" data-testid="process-section" className="bg-ink py-24 text-white lg:py-36">
      <div className="wrap">
        <SectionHead eyebrow="PROCESS" title="THE PROCESS." hl={[1]} dark />
        <div ref={ref} className="relative mt-16 lg:mt-24">
          <div aria-hidden="true" className="absolute bottom-0 left-[23px] top-0 w-[2px] bg-white/10 lg:bottom-auto lg:left-0 lg:right-0 lg:top-[23px] lg:h-[2px] lg:w-auto">
            <motion.div style={{ scaleY: fill }} className="absolute inset-0 origin-top bg-emerald-dot lg:hidden" />
            <motion.div style={{ scaleX: fill }} className="absolute inset-0 hidden origin-left bg-emerald-dot lg:block" />
          </div>
          <ol className="relative grid gap-12 lg:grid-cols-4 lg:gap-8">
            {PROCESS.map((p, i) => (
              <Step key={p.n} p={p} i={i} fill={fill} />
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
